import { render, staticRenderFns } from "./auth-form-header.vue?vue&type=template&id=16563bb2"
import script from "./auth-form-header.vue?vue&type=script&lang=js"
export * from "./auth-form-header.vue?vue&type=script&lang=js"
import style0 from "./auth-form-header.vue?vue&type=style&index=0&id=16563bb2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports